import * as React from "react";
import Empty from "../empty";
import {
    List,
    Create,
    Edit,
    Datagrid,
    TextField,
    TabbedForm,
    FormTab,
    SimpleForm,
    TextInput,
    FunctionField,
    EditButton,
    UrlField,
    SaveButton,
    maxLength,
    minLength,
    TopToolbar,
    CreateButton,
    ExportButton,
    useGetIdentity,
    BulkDeleteButton, ReferenceInput, SelectInput, useRecordContext
} from 'react-admin';
import Toolbar from "@material-ui/core/Toolbar";
import {Button} from "@material-ui/core";
import {BarLoader} from "react-spinner-animated";
import Grid from "@material-ui/core/Grid";
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
} from 'chart.js';
import {
    Bar,
    Chart,
    getDatasetAtEvent,
    getElementAtEvent,
    getElementsAtEvent,
} from 'react-chartjs-2';
ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip
);


const postFilters = [
    <TextInput source="q" label="Search" alwaysOn/>,
];

const ToolbarButtons = (props) => (
    <TopToolbar>
        <CreateButton disabled={!props.identity.admin} label={"Nuovo"}/>
        <ExportButton label={"Esporta"}/>
        {/* Add your custom actions */}
    </TopToolbar>
)

const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton label={"Salva"} submitOnEnter={false} redirect={props.redirect} {...props}/>
        <Button href={"#/manufacturer"}>Annulla</Button>
    </Toolbar>
);

function ResetViewsButton(props) {
    return null;
}

const PostBulkActionButtons = () => (
    <>
        <ResetViewsButton label="Reset Views"/>
        {/* default bulk delete action */}
    </>
)

export const ManufacturerList = (props) => {
    const {identity, loading} = useGetIdentity();
    if (loading) return <BarLoader text={"Caricamento..."}
                                   center={true}/>;
    return (
        <List {...props} perPage={25} filters={postFilters} empty={<Empty/>}
              actions={<ToolbarButtons identity={identity}/>} bulkActionButtons={<PostBulkActionButtons/>}>
            <Datagrid rowClick="edit" optimized>
                <TextField source="name" label="Nome"/>
                <UrlField source="webSiteUrl" label="Sito Web"/>
                {/*<FunctionField label="Indirizzo"
                               render={record => record.address ? `${record.address.streetName ? record.address.streetName : ""}, ${record.address.streetNumber ? record.address.streetNumber : ""} - ${record.address.city ? record.address.city : ""}` : ""}/>*/}
                <TextField source="vatNumber" label="P.IVA"/>
                <TextField source="numberOfProducts" label="#Prodotti"/>
                <TextField source="telephone" label="Telefono"/>
                <EditButton label="Modifica"/>
            </Datagrid>
        </List>
    );
}

export const ManufacturerCreate = (props) => (
    <Create {...props}>
        <TabbedForm toolbar={<PostEditToolbar/>}>
            <FormTab label={"Generali"}>
                <TextInput source="name" label="Nome"/>
                <TextInput source="webSiteUrl" label="Sito Web"/>
                <TextInput label="Indirizzo Email" source="email" type="email"/>
                <TextInput source="vatNumber" label="P.IVA"
                           validate={[maxLength(11, "La P.IVA può essere massimo 11 caratteri."), minLength(11, "La P.IVA deve avere minimo 11 caratteri.")]}/>
                <TextInput source="codiceFiscale" label="Codice Fiscale"
                           validate={[maxLength(16, "Il Codice Fiscale può essere massimo 16 caratteri.")]}/>
                <TextInput source="telephone" label="Telefono" type={"tel"}/>
            </FormTab>
            <FormTab label={"Indirizzo"}>
                <TextInput source="address.streetName" label="Indirizzo"/>
                <TextInput source="address.streetNumber" label="Numero"/>
                <TextInput source="address.city" label="Città"/>
                <TextInput source="address.zipCode" label="CAP"
                           validate={[maxLength(5, "Il cap deve essere massimo 5 caratteri."), minLength(5, "Il cap deve essere almeno 5 caratteri.")]}/>
            </FormTab>
        </TabbedForm>
    </Create>
);

export const ManufacturerEdit = (props) => {
    const {identity, loading} = useGetIdentity();
    if (loading) return <BarLoader text={"Caricamento..."}
                                   center={true}/>;
    return (
        <Edit {...props}>
            <TabbedForm toolbar={<PostEditToolbar/>}>
                <FormTab label={"Generali"}>
                    <TextInput disabled label="Id" source="id"/>
                    <TextInput disabled={!identity.admin} source="name" label="Nome"/>
                    <TextInput disabled={!identity.admin} source="webSiteUrl" label="Sito Web"/>
                    <TextInput disabled={!identity.admin} label="Indirizzo Email" source="email" type="email"/>
                    <TextInput disabled={!identity.admin} source="vatNumber" label="P.IVA"
                               validate={[maxLength(11, "La P.IVA può essere massimo 11 caratteri."), minLength(11, "La P.IVA deve avere minimo 11 caratteri.")]}/>
                    <TextInput disabled={!identity.admin} source="codiceFiscale" label="Codice Fiscale"
                               validate={[maxLength(16, "Il Codice Fiscale può essere massimo 16 caratteri.")]}/>
                    <TextInput disabled={!identity.admin} source="telephone" label="Telefono" type={"tel"}/>
                </FormTab>
                <FormTab label={"Indirizzo"}>
                    <TextInput disabled={!identity.admin} source="address.streetName" label="Indirizzo"/>
                    <TextInput disabled={!identity.admin} source="address.streetNumber" label="Numero"/>
                    <TextInput disabled={!identity.admin} source="address.city" label="Città"/>
                    <TextInput disabled={!identity.admin} source="address.zipCode" label="CAP"
                               validate={[maxLength(5, "Il cap deve essere massimo 5 caratteri."), minLength(5, "Il cap deve essere almeno 5 caratteri.")]}/>
                </FormTab>
                <FormTab label={"Statistiche"}>
                    <TextField source={"numberOfProducts"} label={"Numero di Prodotti Totale"}/>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                        </Grid>
                    </Grid>
                </FormTab>
            </TabbedForm>
        </Edit>
    );
}

const labels = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
export const data = {
    labels,
    datasets: [
        {
            label: 'Anno 2023',
        },
    ],
};
export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Chart.js Bar Chart',
        },
    },
};
